module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#filter",
      toString: function () {
        return this.url;
      }
    }